import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Quasar, Notify, Dialog } from 'quasar';
import quasarLang from 'quasar/lang/fr';

import { i18n } from './plugins/i18n';
import { useAuthStore, useCommunityStore, useConfigurationStore } from './stores';
import VueCookies from 'vue-cookies';
import axios from 'axios';

// Import icon libraries
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';

// Import Quasar css
import 'quasar/src/css/index.sass';
import 'mapbox-gl/dist/mapbox-gl.css';

import App from './App.vue';
import router from './router';

async function init() {
  axios.defaults.withCredentials = true;

  const pinia = createPinia();

  const authStore = useAuthStore(pinia);
  await authStore.init();
  if (authStore.user) {
    const communityStore = useCommunityStore(pinia);
    await communityStore.fetchCommunities();
    const configurationStore = useConfigurationStore(pinia);
    await configurationStore.init();
  }

  const app = createApp(App);

  app.use(pinia);
  app.use(router);
  app.use(i18n);

  app.use(VueCookies, { expires: '1m' });
  app.use(Quasar, {
    plugins: {
      Notify,
      Dialog,
    }, // import Quasar plugins and add here
    lang: quasarLang,
    /*
        config: {
          brand: {
            // primary: '#e46262',
            // ... or all other brand colors
          },
          notify: {...}, // default set of options for Notify Quasar plugin
          loading: {...}, // default set of options for Loading Quasar plugin
          loadingBar: { ... }, // settings for LoadingBar Quasar plugin
          // ..and many more (check Installation card on each Quasar component/directive/plugin)
        }
        */
  });

  app.mount('#app');
}

init();
